import { Color, FontSize, FontWeight } from 'theme/style'

const typography = {
  h1: {
    fontFamily: 'Poppins, sans-serif',
    color: Color.TextPrimary,
    fontWeight: FontWeight.SemiBold,
    fontSize: FontSize.Headline1,
    letterSpacing: '-1px',
    lineHeight: 1.3
  },
  h2: {
    fontFamily: 'Poppins, sans-serif',
    color: Color.TextPrimary,
    fontWeight: FontWeight.SemiBold,
    fontSize: FontSize.Headline2,
    letterSpacing: '-0.5',
    lineHeight: 1.1
  },
  h3: {
    fontFamily: 'Poppins, sans-serif',
    color: Color.TextPrimary,
    fontWeight: FontWeight.Medium,
    fontSize: FontSize.Headline3,
    letterSpacing: -0.5,
    lineHeight: 1
  },
  h4: {
    fontFamily: 'Poppins, sans-serif',
    color: Color.TextPrimary,
    fontWeight: FontWeight.Medium,
    fontSize: FontSize.Headline4,
    letterSpacing: -0.2,
    lineHeight: 1
  },
  h5: {
    fontFamily: 'Poppins, sans-serif',
    color: Color.TextPrimary,
    fontWeight: FontWeight.Medium,
    fontSize: FontSize.Headline5,
    letterSpacing: 0,
    lineHeight: 1.5
  },
  h6: {
    fontFamily: 'Poppins, sans-serif',
    color: Color.TextPrimary,
    fontWeight: FontWeight.Medium,
    fontSize: FontSize.Headline6,
    letterSpacing: 0,
    lineHeight: 1.5
  },
  subtitle1: {
    fontFamily: 'Mulish, sans-serif',
    color: Color.TextPrimary,
    fontWeight: FontWeight.Medium,
    fontSize: FontSize.Subtitle1,
    letterSpacing: 0,
    lineHeight: 1.3
  },
  subtitle2: {
    fontFamily: 'Mulish, sans-serif',
    color: Color.TextSecondary,
    fontWeight: FontWeight.Medium,
    fontSize: FontSize.Subtitle2,
    letterSpacing: 0,
    lineHeight: 1.5
  },
  body1: {
    fontFamily: 'Mulish, sans-serif',
    color: Color.TextSecondary,
    fontWeight: FontWeight.Regular,
    fontSize: FontSize.Body1,
    letterSpacing: 0,
    lineHeight: 1.7
  },
  body2: {
    fontFamily: 'Mulish, sans-serif',
    color: Color.TextLight,
    fontSize: FontSize.Body2,
    fontWeight: FontWeight.Medium,
    letterSpacing: 0,
    lineHeight: 1.5
  },
  cell: {
    fontFamily: 'Mulish, sans-serif',
    color: Color.TextPrimary,
    fontSize: FontSize.Cell,
    fontWeight: FontWeight.Regular,
    letterSpacing: 0,
    lineHeight: 1.5
  },
  button: {
    fontFamily: 'Poppins, sans-serif',
    color: Color.TextPrimary,
    fontSize: FontSize.Button,
    fontWeight: FontWeight.SemiBold,
    letterSpacing: 0,
    lineHeight: 2,
  },
  caption: {
    fontFamily: 'Mulish, sans-serif',
    color: Color.TextSecondary,
    fontSize: FontSize.Caption,
    fontWeight: FontWeight.Regular,
    letterSpacing: 0.3,
    lineHeight: 1.3
  },
  overline: {
    fontFamily: 'Mulish, sans-serif',
    color: Color.TextPrimary,
    fontSize: FontSize.Overline,
    fontWeight: FontWeight.Bold,
    letterSpacing: 0.4,
    lineHeight: 1,
    textTransform: 'uppercase'
  }
}

export default typography
